import { useCallback, useContext } from 'react';
import { useActivePosEntityContext } from 'src/contexts/ActivePosEntityContext';
import { IPosEntity } from 'src/contexts/ActivePosEntityContext/ActivePosEntityContext';
import { IMultiEntityContext } from 'src/contexts/ActivePosEntityContext/ActivePosEntityContextV2';
import { ModalContext } from 'src/contexts/ModalContext';
import { ActionOutboxEntityType } from 'src/WebApiController';

/**
 * Base hook for entity actions that provides common functionality
 * for loading entities and opening their modals.
 */
export const useEntityActions = () => {
  const { setActivePosEntity } =
    useActivePosEntityContext() as IMultiEntityContext<IPosEntity>;
  const { setModal } = useContext(ModalContext);

  const loadEntityAndOpenModal = useCallback(
    (
      entityType: ActionOutboxEntityType,
      entityId: number | string,
      entityDisplayId: string | null,
      forceRefresh: boolean,
      dataToGet: string[],
      resetData: boolean,
      sectional: boolean,
      getModalConfig: (id: number | string) => any
    ) => {
      // Start entity loading/switching (async)
      setActivePosEntity(
        Number(entityId),
        entityDisplayId,
        forceRefresh,
        dataToGet,
        resetData,
        sectional,
        entityType
      );

      setModal(getModalConfig(entityId));
    },
    [setActivePosEntity, setModal]
  );

  return { loadEntityAndOpenModal };
};
